import PropTypes from 'prop-types';

export const IdType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export const DropdownOptionsType = PropTypes.shape({
	targetElement: PropTypes.any,
	targetNodeId: IdType,
	onAddClick: PropTypes.func,
	onRenameClick: PropTypes.func,
	onRemoveClick: PropTypes.func
});

export const TooltipOptionsType = PropTypes.shape({
	targetElement: PropTypes.any,
	tooltipContent: PropTypes.string
});

export const TreeOptionsType = PropTypes.shape({
	rootName: PropTypes.string,
	activeRootOnInit: PropTypes.bool,
	activeNodeOnClick: PropTypes.bool,
	expandRootOnInit: PropTypes.bool,
	orderPredicate: PropTypes.func,
	disableDropdown: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
	disableDrag: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
	disableDrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
});

export class NodeItem {
	constructor() { }

	static parse({ id, name, parent, type, children, options }) {
		return {
			id: id || undefined,
			name: name || '',
			parent: parent || undefined,
			type: type || undefined,
			children: children || [],
			options: Object.assign({
				isEditingMode: false
			}, options)
		}
	}

	static parseList(nodes) {
		return nodes.map(({ id, name, parent, type, children, options }) => ({
			id: id || undefined,
			name: name || '',
			parent: parent || undefined,
			type: type || undefined,
			children: children || [],
			options: Object.assign({
				isEditingMode: false
			}, options)
		}));
	}
}


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/Reactree/ReactreeUtils.js